import { HttpClient, HttpHeaders } from '@angular/common/http';
// import { Component, OnInit, ViewChild } from '@angular/core';
import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { UmsService } from '../ums.service';
import { environment } from 'src/environments/environment';
import { HttpErrorResponse } from '@angular/common/http';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { ConformationModelComponent } from '../conformation-model/conformation-model.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-std-attendance-dialog-box',
  templateUrl: './std-attendance-dialog-box.component.html',
  styleUrls: ['./std-attendance-dialog-box.component.scss']
})
export class StdAttendanceDialogBoxComponent implements OnInit {
 
  AttendanceForm: FormGroup;
  SessionFilterList: any;
  sessionList: any;
  filteredListFcCode: any;
  fcCodeList: any;
  BranchList: any;
  filteredListBranch: any;
  filteredListExam: any;
  examList: any;
  selectDropdown: any;
  filterlist: any;
  childrenData: any;
  dataSource: any;
  filteredCourseList: any;
  courseList: any;
  filteredCollegeList: any;
  collegeList: any;
  filteredListExamSub: any;
  examSubList: any;
  AtdArray: FormArray;
  submitButton = false;
  editButton = false;
  showSubmitButton = true;
 deleteButton: boolean;
  Add = true;
  Update = false;
  Delete = false;
  sessionId: any;
  CoCode: any;
  CgCode: any;
  atdTbl = false;
  AtdTable = [];
  submitpayload: any;
  errMsg: any;
  currentDate: Date;
  formattedDate: string;
  dialogRef: MatDialogRef<any>;
  attendanceList: any;
  APIService: any;
  resData: any;
  id: any;
  DeleteData: any;
  UpdateData: any;
 
  constructor(public umsService: UmsService, private dialogRef2: MatDialogRef<StdAttendanceDialogBoxComponent>,
    private modalPopupService: ModalpopService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private spinner: NgxSpinnerService,private datePipe: DatePipe) 
    { this.APIService = environment.serviceUrl; }

    formatDate() {
      const currentDate = new Date();
      const formattedDate = this.datePipe.transform(currentDate, 'dd/MM/yyyy');
      return formattedDate;
    }
    
  ngOnInit(): void {
    
    this.submitButton = false;
    this.editButton = false;
    this.Add = true;
    this.Update = false;
    this.Delete = false;
    this.sessionId = '';
    this.CoCode = '';
    this.CgCode = '';
    this.fetchSession();
    this.fetchFaculty();
    this.getExam();
    this.getCourse();
    this.getCollege();
    this.AttendanceForm = this.fb.group({
      Session: new FormControl(''),
      ExamName: new FormControl(''),
      Faculty: new FormControl(''),
      Course: new FormControl(''),
      College: new FormControl(''),
      Branch: new FormControl(''),
      Exam: new FormControl(''),
      Subject: new FormControl(''),
      AtdArray: new FormArray([])
    });

    this.atdTbl = false;
    this.addnewrow();
    this.formattedDate = this.formatDate();
    if (this.data.key == "Edit") {
      this.UpdateData = this.data.selected;
      this.prepopulation(this.data.selected);
    } else if (this.data.key == "Delete") {
      this.DeleteData = this.data.selected;
      this.prepopulationForDelete(this.data.selected);
    } else {
      // alert(this.data.key) 
    }
  }

  getAtdArrayControls() {
    return (this.AttendanceForm.get('AtdArray') as FormArray).controls;
  }


  addnewrow() {
    this.AtdArray = this.AttendanceForm.get('AtdArray') as FormArray;
    this.AtdArray.push(
      this.fb.group({
        SrNo: new FormControl(''),
        PrNo: new FormControl(''),
        StuName: new FormControl(''),
        AtndPrcnt: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
      })
    );

  }

  fetchSession() {
    this.spinner.show();
    const payload = {};
    this.umsService.getSession(payload).subscribe(res => {
      this.spinner.hide();
      this.sessionList = [];
      if (res.status) {
        res.data.forEach(element => {
          if (element.SnStatus == 'O') {
            this.sessionList.push(element);
          }
        });
        this.SessionFilterList = this.sessionList.slice();
      }
    })
  }

  fetchFaculty() {
    const payload = {};
    this.umsService.getFaculty(payload).subscribe(res => {
      if (res.status) {
        this.fcCodeList = res.data;
        this.filteredListFcCode = this.fcCodeList.slice();
      }
    })
  }

  fetchBranch(x) {
    this.CoCode = x;
    const payload = {};
    payload['CoCode'] = x;
    this.umsService.getExamStream(payload).subscribe(res => {
      if (res.status) {
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
      }
    });
  }

  getExam() {
    this.spinner.show();
    const payload = {};
    this.umsService.getExam(payload).subscribe(res => {
      if (res.status) {
        this.examList = res.data;
        this.spinner.hide();
        this.filteredListExam = this.examList.slice();
      }
      else {
        this.spinner.hide();
      }
    });
  }

  getSubjects(x) {
    this.spinner.show();
    const payload = {};
    payload['EsEmId'] = x;
    this.umsService.getExamSubMapFetch(payload).subscribe(res => {
      this.spinner.hide();
      res.data.children.forEach(element => {
        if (element.EsType == 'S') {
          this.examSubList = res.data.children;
          this.filteredListExamSub = this.examSubList.slice();
        }
        else if (element.EsType == 'G') {
          this.examSubList = element.children;
          this.filteredListExamSub = this.examSubList.slice();
        }
      });
    });
  }

  getCourse() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCourse(payload).subscribe(res => {
      this.spinner.hide();
      this.courseList = res.data;
      this.filteredCourseList = this.courseList.slice();
    });
  }

  getCollege() {
    this.spinner.show();
    const payload = {};
    this.umsService.getCollege(payload).subscribe((res) => {
      this.collegeList = res.data;
      this.filteredCollegeList = this.collegeList.slice();
      this.spinner.hide();
    })
  }

  reset() {
    this.sessionId = '';
    this.CoCode = '';
    this.CgCode = '';
    this.fetchSession();
    this.fetchFaculty();
    this.getExam();
    this.getCourse();
    this.getCollege();
    this.AttendanceForm = this.fb.group({
      Session: new FormControl(''),
      ExamName: new FormControl(''),
      Faculty: new FormControl(''),
      Course: new FormControl(''),
      College: new FormControl(''),
      Branch: new FormControl(''),
      Exam: new FormControl(''),
      Subject: new FormControl(''),
      AtdArray: new FormArray([])
    });

    this.atdTbl = false;
    this.addnewrow();
    this.formattedDate = this.formatDate();
  }


  session(SnId) {
    this.sessionId = SnId
  }

  ClgCd(CgCode) {
    this.CgCode = CgCode;
  }

  ShowTable() {
    const payload = {};
    this.atdTbl = false;
    this.AtdTable = [];
    this.AtdArray = this.AttendanceForm.get('AtdArray') as FormArray;
    this.AtdArray.clear();
    payload['UserId'] = sessionStorage.getItem('userId');
    payload['SessionId'] = this.sessionId;
    payload['CoCode'] = this.CoCode;
    payload['CgCode'] = this.CgCode
    this.umsService.getAppStu(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.atdTbl = true;
        this.AtdTable = res.data;
        this.AtdArray = this.AttendanceForm.get('AtdArray') as FormArray;
        this.AtdTable.map((element, i) => {
          this.AtdArray.at(i).get('SrNo').setValue(i+1);
          this.AtdArray.at(i).get('PrNo').setValue(element['StuRgNo']);
          this.AtdArray.at(i).get('StuName').setValue(element['StuFirstNameEng'] + element['StuMidNameEng'] + element['StuLastNameEng']);

        });
      }
      else {
        this.atdTbl = false;
      }
    });
  }
 
  Submit(code){
    this.submitpayload = this.AttendanceForm.value;
    const payload = {};
    payload['SnNo'] = this.submitpayload.Session
    payload['SnSrNo'] = 0
    payload['ExmId'] = 0
    payload['ExmSrNo'] = ''
    payload['EmId'] = this.submitpayload.Exam
    payload['EsId'] = this.submitpayload.Subject
    payload['EsThPr'] = ''
    this.umsService.addStdAttendance(payload).subscribe((res) => {
      // this.spinner.hide();
      if (res.status) {
        this.enterAttendance(res.id,code)
      }
      else {
       
      }
    });
  }
  enterAttendance(id,code){
    this.submitpayload = this.AttendanceForm.value;
    let arraypayload = this.AttendanceForm.get('AtdArray') as FormArray;
    let payload = arraypayload.value;
    let iserror = false;
    var bar = new Promise<void>((resolve, reject) => {
      payload.forEach((element, index, array) => {
        let arr1 = [];
        arr1.push(
          this.fb.group({
            AtndId: new FormControl(parseInt(id)),
            CgId: new FormControl(1),
            RgNo: new FormControl(''),
            AfId: new FormControl(this.submitpayload['Faculty']),
            AtndPrcnt: new FormControl(parseInt(element.AtndPrcnt)),
            AtndFlag: new FormControl(''),
            ExmProStat: new FormControl(''),
            EntryFlag: new FormControl(''),
            EntryUser: new FormControl(parseInt(sessionStorage.getItem('userId'))),
            EntryTime: new FormControl(this.formattedDate),
          })
        )
        this.umsService.EnterStdAttendance(arr1[0].value).subscribe(res => {
          this.spinner.hide();
          if (res.status == false) {
            iserror = true;
            this.errMsg = res.message
          }
          if (index === array.length - 1) resolve();
          else {
            iserror = false
            this.errMsg = res.message
          }
        }, (ERROR: HttpErrorResponse) => {
          iserror = true;
          this.errMsg = ERROR.error.message
          if (index === array.length - 1) resolve();
        });
      });
    })
    bar.then(() => {
      if (iserror == false) {
        if(code == 'new'){
          let data = {}
          data['message'] = "Submitted Successfully"
          data['title'] = 'Information'
          data['icon'] = 'fas fa-check'
          this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
          this.dialogRef.afterClosed().subscribe(result => {
            this.dialogRef2.close();
          });
        }
        else if(code == 'old'){
          let data = {}
        data['message'] = "Updated Successfully"
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        }
      } else {
        let data = {}
        data['message'] = this.errMsg
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);

      }
    });
  }

  prepopulation(data){
    this.id = data.AtndId
    this.editButton = true;
    this.submitButton = false;
    this.deleteButton = false;
    this.Update = true;
    this.Add = false;
    this.Delete = false;
    this.atdTbl = true;
    const payload = {};
    payload['Id'] = data.AtndId;
    payload['SearchString'] = '';
    payload['PageSize'] = '';
    payload['PageNumber'] = '';
    this.umsService.searchStudentAttendance(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.resData = res.data[0];
        this.AttendanceForm = this.fb.group({
          Session: new FormControl(this.resData['SnNo']),
          ExamName: new FormControl(this.resData['ExmId']),
          Faculty: new FormControl(''),
          Course: new FormControl(''),
          College: new FormControl(''),
          Branch: new FormControl(''),
          Exam: new FormControl(this.resData['EmId']),
          Subject: new FormControl(this.resData['EsId']),
          AtdArray: new FormArray([])
        });
        this.TableArray(res.data)
      }
    })
    
  }

  prepopulationForDelete(data){
    this.id = data.AtndId
    this.editButton = false;
    this.submitButton = false;
    this.deleteButton = true;
    this.Update = false;
    this.Add = false;
    this.Delete = true;
    this.atdTbl = true;
    const payload = {};
    payload['Id'] = data.AtndId;
    payload['SearchString'] = '';
    payload['PageSize'] = '';
    payload['PageNumber'] = '';
    this.umsService.searchStudentAttendance(payload).subscribe(res => {
      this.spinner.hide();
      if (res.status) {
        this.resData = res.data[0];
        this.AttendanceForm = this.fb.group({
          Session: new FormControl(this.resData['SnNo']),
          ExamName: new FormControl(this.resData['ExmId']),
          Faculty: new FormControl(''),
          Course: new FormControl(''),
          College: new FormControl(''),
          Branch: new FormControl(''),
          Exam: new FormControl(this.resData['EmId']),
          Subject: new FormControl(this.resData['EsId']),
          AtdArray: new FormArray([])
        });
        this.TableArray(res.data)
      }
    })

  }

  TableArray(data) {
        this.atdTbl = true;
        this.AtdTable = data;
        this.AtdTable.forEach((element, i) => {
          const creds = this.AttendanceForm.controls.AtdArray as FormArray;
          creds.push(
            this.fb.group({
              SrNo: new FormControl(element.RowNum),
              PrNo: new FormControl(element.AtndId),
              StuName: new FormControl(''),
              AtndPrcnt: new FormControl(element.AtndPrcnt, [Validators.required, Validators.pattern('^[0-9]*$')]),
            })
          );
          
        });
     
  }

  update(){
    let id = this.UpdateData
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        Id: id.AtndId,
        AtndId: id.AtndId,
        CgId: id.CgId,
        RgNo: id.RgNo,
        AfId: id.AfId,
        AtndPrcnt: id.AtndPrcnt,
        AtndFlag: id.AtndFlag,
        ExmProStat: id.ExmProStat,
        EntryFlag: id.EntryFlag,
        EntryUser: id.EntryUser,
        EntryTime: id.EntryTime,
      },
    };
    this.httpClient.delete(this.APIService + '/supervisor/CtStuAtndEntry', options)
      .subscribe((s) => {
        this.spinner.hide();
        this.Submit('old');
        // this.spinner.hide();
        // let cc = [];
        // cc.push(s);
        // let data = {}
        // data['message'] = 'Updated Successfully'
        // data['title'] = 'Information'
        // data['icon'] = 'fas fa-check'
        // this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        // this.dialogRef.afterClosed().subscribe(result => {
          
        // });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

   
  }

  DeletetheRecord() {
    const data = {};
    data['message'] = 'Are You Sure You Want To Delete This Record ?';
    data['title'] = 'Alert';
    data['icon'] = 'fa fa-question';
    this.dialogRef = this.modalPopupService.openPopup<ConformationModelComponent>(ConformationModelComponent, data);
    this.dialogRef.afterClosed().subscribe(result => {
      if (result === 'yes') {
        this.delete(this.DeleteData);
        this.dialogRef2.close();
      } else {
        // this.ngOnInit();
        this.dialogRef2.close();
      }
    });
  }


  delete(id) {
    this.spinner.show();
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }), body: {
        Id: id.AtndId,
        AtndId: id.AtndId,
        CgId: id.CgId,
        RgNo: id.RgNo,
        AfId: id.AfId,
        AtndPrcnt: id.AtndPrcnt,
        AtndFlag: id.AtndFlag,
        ExmProStat: id.ExmProStat,
        EntryFlag: id.EntryFlag,
        EntryUser: id.EntryUser,
        EntryTime: id.EntryTime,
      },
    };
    this.httpClient.delete(this.APIService + '/supervisor/CtStuAtndEntry', options)
      .subscribe((s) => {
        this.spinner.hide();
        // this.spinner.hide();
        let cc = [];
        cc.push(s);
        let data = {}
        data['message'] = cc[0].message
        data['title'] = 'Information'
        data['icon'] = 'fas fa-check'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.dialogRef.afterClosed().subscribe(result => {
          this.ngOnInit();
        });
      }, (ERROR: HttpErrorResponse) => {
        this.spinner.hide();
        let data = {}
        data['message'] = ERROR.error.message
        data['title'] = 'Alert'
        data['icon'] = 'fas fa-close'
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
        this.ngOnInit();
        // this.umsService.openSnackbar(ERROR.error.message);

      });

  }


}
